export default __webpack_public_path__ + "static/media/1581.6d5c3dc6.png";